import { createUseStyles } from 'react-jss';

export default createUseStyles({
  carouselViewerModal: {
    width: '100vw',
    height: '100vh',
    backgroundColor: 'transparent',
    color: 'white',
    top: 0,
    '&.ant-modal-wrap': {
      '& .ant-modal': {
        top: '0px',
        paddingBottom: '0px',
        '& .ant-modal-content': {
          height: '100vh',
          backgroundColor: 'transparent',
          border: 'none !important',
          display: 'flex',
          flexDirection: 'column',
          '& .ant-modal-close': {
            display: 'none',
          },
          '& .ant-modal-header': {
            backgroundColor: 'transparent',
            padding: '8px 0px !important',

            '@media (min-width: 768px)': {
              padding: '24px 80px !important',
            },

            '& .ant-modal-title': {
              color: 'white !important',
            },
          },
          '& .ant-modal-body': {
            flex: 1,
            '& .ant-carousel': {
              height: '100%',
            },
          },
        },
      },
    },
  },
  carousel: {
    height: '100%',
    '& .slick-list': {
      height: '100%',
      '& .slick-track': {
        height: '100%',
        '& .slick-slide': {
          '& >div': {
            height: '100%',
            '& >div': {
              height: '100%',
              display: 'flex !important',
              justifyContent: 'center',
              maxHeight: 'calc(100vh - 160px)',
            },
          },
        },
      },
    },
    '& circle': {
      stroke: 'white',
    },
    '& path': {
      fill: 'white',
    },
    '& .slick-dots-bottom': {
      bottom: '-16px !important',
    },
  },
});
